import React, { useEffect, useState } from "react";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import EditClubInfoForm from "./EditClubInfoForm";

export default function ClubInfoSection({ schoolId, clubId }) {
    const [clubData, setClubData] = useState(null);
    const [editing, setEditing] = useState(false);

    useEffect(() => {
        const fetchClub = async () => {
            const ref = doc(db, "schools", schoolId, "clubs", clubId);
            const snap = await getDoc(ref);
            if (snap.exists()) {
                setClubData(snap.data());
            }
        };
        fetchClub();
    }, [schoolId, clubId]);

    const handleSave = async (updatedData) => {
        const ref = doc(db, "schools", schoolId, "clubs", clubId);
        await updateDoc(ref, updatedData);
        setClubData(updatedData);
        setEditing(false);
    };

    if (!clubData) return <p>Loading club info...</p>;

    return (
        <div className="club-info-section">
            {!editing ? (
                <div>
                    <img src={clubData.logo} alt="Club Logo" style={{ width: 120 }} />
                    <p><strong>Description:</strong> {clubData.description}</p>
                    <p><strong>Vision:</strong> {clubData.vision}</p>
                    <p><strong>Values:</strong></p>
                    <ul>{clubData.values?.map((v, i) => <li key={i}>{v}</li>)}</ul>
                    <p><strong>Mission:</strong></p>
                    <ul>{clubData.mission?.map((m, i) => <li key={i}>{m}</li>)}</ul>
                    <p><strong>Objective:</strong></p>
                    <ul>{clubData.objective?.map((o, i) => <li key={i}>{o}</li>)}</ul>
                    <button onClick={() => setEditing(true)}>Edit</button>
                </div>
            ) : (
                <EditClubInfoForm
                    data={clubData}
                    onSave={handleSave}
                    onCancel={() => setEditing(false)}
                />
            )}
        </div>
    );
}